export const NotStartedIcon = () => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8125 10.5208C13.64 8.86415 15.5 6.35831 15.5 3.02081C15.5 1.64248 14.3783 0.520813 13 0.520813H3C1.62167 0.520813 0.5 1.64248 0.5 3.02081C0.5 6.35915 2.36667 8.86415 4.20167 10.5208C2.36667 12.1775 0.5 14.6833 0.5 18.0208V20.5208H15.5V18.0208C15.5 14.6841 13.6408 12.1775 11.8125 10.5208ZM13.8333 18.8541H2.16667V18.0208C2.16667 14.8758 4.25667 12.5616 6.01 11.1741L6.83583 10.5208L6.01 9.86748C4.25667 8.47998 2.16667 6.16665 2.16667 3.02165C2.16667 2.56248 2.54083 2.18831 3 2.18831H13C13.4592 2.18831 13.8333 2.56165 13.8333 3.02165C13.8333 6.16665 11.7525 8.48165 10.0067 9.86915L9.18667 10.5216L10.0067 11.1741C11.7525 12.5625 13.8333 14.8775 13.8333 18.0216V18.8541ZM12.1017 3.85415H3.9C4.32167 6.48498 6.64833 8.36581 8.01167 9.25998C9.36167 8.37831 11.6842 6.50665 12.1017 3.85415ZM8.015 7.20248C7.47917 6.76915 6.8725 6.19748 6.39 5.52081H9.63417C9.16667 6.18831 8.5725 6.75498 8.015 7.20248Z"
      fill="currentColor"
    />
  </svg>
);
